// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__mVW2r","btnBlue":"button_btnBlue__kIToR","btnSmall":"button_btnSmall__lzf9S","btnDisabled":"button_btnDisabled__H4Pow"};